import { Component } from 'react';
export class NineAssetHealthCheck extends Component {
    render(){
        return (
            <div>
                {'NineAssetHealthCheck'}
            </div>
        )
    }
}
